import {createContext} from 'react'

export const BadgeDetailsContext = createContext<any>({
  badgeDetails: {},
  isLoading: false,
  filters: {},
  onSearch: () => {},
  onSortingChange: () => {},
  isLoadingProducts: false,
  products: [],
  brands: [],
  categories: [],
  isLoadingBrands: false,
  isLoadingCategories: false,

  addProductBadge: (data: any, setError: any) => {},
  updateProductBadge: (data: any, badgeId: string, dirtyFields: any, setError: any) => {},
  isOperationLoading: false,
})

export const BadgeProductsContext = createContext<any>({
  products: [],
  pagination: {},
  isLoading: false,
  filters: {},
  onSortingChange: () => {},
  onChangeBrandFilter: () => {},
  onSearch: () => {},
  onChangeCategoryFilter: () => {},
  onPageChange: () => {},
  checkedRows: [],
  setCheckedRows: () => {},
  categories: [],
  brands: [],
  isLoadingBrands: false,
  isLoadingCategories: false,
  deleteProductBadge: (badgeId: string) => {},
  isOperationLoading: false,
  totalCount: 0,  
})
